<template>
  <wrap-container>
    <radio-options />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import RadioOptions from "@/components/RadioOptions";

export default {
  components: {
    WrapContainer,
    RadioOptions
  }
};
</script>
